import React, { useCallback, useEffect, useState } from 'react';
import { getReportSheets } from '../../api/dashboard';
import { errorCode } from '../../api/client';
import { useAuth } from '../../auth/AuthContext';
import PageHeader from '../../components/PageHeader';
import PhoneApp from '../../components/PhoneApp';
import StatusMessage from '../../components/StatusMessage';
import './Admin.css';

// Charge nurses only: Aren through the dashboard. The phone shows what
// they see when they log in to the app on their own iPhone: their home screen
// and their own patients, each opening its report sheet in the phone. Browse
// only for now; editing and recording are done in the app.
const MyApp = () => {
  const me = useAuth()?.nurse || {};
  const [sheets, setSheets] = useState(null);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setError(null);
    try {
      const data = await getReportSheets();
      setSheets((data.units || []).flatMap((u) => u.reportSheets || []).filter((s) => s.owner?.isMine));
    } catch (err) {
      // 401 is handled globally (sign-out).
      if (errorCode(err) !== 'unauthenticated') setError(errorCode(err));
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const name = [me.firstName, me.lastName].filter(Boolean).join(' ');

  return (
    <>
      <PageHeader title="Aren App" />
      {error || !sheets ? (
        <div className="component-container">
          <div className="admin-content">
            {error ? (
              <StatusMessage kind="error" onRetry={load}>
                {error === 'network_error'
                  ? "Can't reach the dashboard server. Check your connection."
                  : "We couldn't load your patients."}
              </StatusMessage>
            ) : (
              <StatusMessage kind="loading">Loading your patients…</StatusMessage>
            )}
          </div>
        </div>
      ) : (
        <div className="component-container phone-page">
          <PhoneApp
            firstName={me.firstName}
            nurseName={name}
            sheets={sheets}
            label="Your Aren app"
            caption="What you see in the Aren app. Editing and recording are done on your phone."
            blankText="Patients you add in the Aren app will show up here."
          />
        </div>
      )}
    </>
  );
};

export default MyApp;
